module.exports = __webpack_public_path__ + "static/media/YF52_0.ef294edb.jpg";